import Router from "./routing";
import React from 'react';
const Main=()=>{
    return(
        <Router/>
    )
}
export default Main;